import { BRAND } from '../config'

const storage = BRAND

export const getCity = () => localStorage.getItem(storage.peugeot)

export const setCity = (city: string) => {
  console.log(BRAND, city)
  localStorage.setItem(storage.peugeot, city)
}
